import styles from "./Program.module.css";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";
import { IoMdTrash } from "react-icons/io";
import Dynamic from "../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import Action from "../../components/Action/Action";
import IconAndName from "../../components/IconAndName/IconAndName";
import { FaUserPlus } from "react-icons/fa";
import { LuClock3 } from "react-icons/lu";
import CopyRight from "../../components/CopyRight/CopyRight";

const data = [
  {
    _id: "1",
    name: "John Jacob",
    dateRange: "2905/25 - 30/05/25",
    duration: "8:00 AM–11:00 AM",
    room: "3A",
    feeCount: 0,
    status: "Active",
    occupancy: 0,
    actionOptions: ["Edit", "Delete"],
  },
  {
    _id: "2",
    name: "John Jacob",
    dateRange: "29/05/25 - 30/05/25",
    duration: "8:00 AM–11:00 AM",
    room: "3A",
    feeCount: 0,
    status: "Active",
    occupancy: 0,
    actionOptions: ["Edit", "Delete"],
  },
  {
    _id: "3",
    name: "John Jacob",
    dateRange: "29/05/25 - 30/05/25",
    duration: "8:00 AM–11:00 AM",
    room: "3A",
    feeCount: 0,
    status: "Active",
    occupancy: 0,
    actionOptions: ["Edit", "Delete"],
  },
];

function Program() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const handleAddProgram = () => {
    dispatch(openModal("addProgram"));
  };
  const handlecheckAvailability = () => {
    dispatch(openModal("checkAvailability"));
  };

  const getColumnData = (data) => {
    return data?.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              if (checked) {
                setSelectedIds((prev) => [...prev, item._id]);
              } else {
                setSelectedIds((prev) => prev.filter((id) => id !== item._id));
              }
            }}
          />
        ),
        programName: (
          <LogoWithName name={item.name} dateRange={item.dateRange} />
        ),
        duration: (
          <div style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
            <LuClock3 size={14} />
            <span>{item.duration}</span>
          </div>
        ),
        room: item.room,
        feeCount: item.feeCount,
        status: (
          <Dropdown label={item.status} options={["Active", "Inactive"]} />
        ),
        occupancy: item.occupancy,
        action: (
          <Action
            key={item._id}
            options={item.actionOptions}
            onSelect={(opt) => {
              if (opt === "Edit") dispatch(openModal("TransferStudent"));
              else if (opt === "Delete") dispatch(openModal("delete"));
            }}
          />
        ),
      };
    });
  };

  const displayData = getColumnData(data);

  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            if (checked) {
              const allIds = data.map((item) => item._id);
              setSelectedIds(allIds);
            } else {
              setSelectedIds([]);
            }
          }}
        />
      ),
      accessor: "checkBox",
    },
    { title: "Program Name", accessor: "programName" },
    { title: "Duration", accessor: "duration" },
    { title: "Room", accessor: "room" },
    { title: "Fee Plan Count", accessor: "feeCount" },
    { title: "Status", accessor: "status" },
    { title: "Today Occupancy", accessor: "occupancy" },
    { title: "Action", accessor: "action" },
  ];

  return (
    <div className={styles.copyright}>
      <div className={styles.programcontainer}>
        <div className={styles.container}>
          <div className={styles.headerContainer}>
            <IconAndName
              icon={<FaUserPlus />}
              title="Add Program"
              bgColor="Primary_Color"
              onClick={handleAddProgram}
            />
          </div>

          <div className={styles.resultandcount}>
            <ResultAndCount
              label="Total Number Of Programs"
              count={10}
              bgColor="rgba(from var(--Success_Color) r g b / 0.4)"
              textColor="Black_Color"
            />
            <ResultAndCount
              label="Students starting Program This Week"
              count={2}
              bgColor="rgba(from var(--Primary_Color) r g b / 0.35)"
              textColor="Black_Color"
            />
            <ResultAndCount
              label="Students Leaving Program This Week"
              count={5}
              bgColor="rgba(from var(--Error_Color) r g b / 0.4)"
              textColor="Black_Color"
            />
            <ResultAndCount
              label="Students Without Active Program"
              count={1}
              bgColor="rgba(from var(--Warning_Color) r g b / 0.3)"
              textColor="Black_Color"
            />
          </div>

          <div className={styles.totalstudentcard}>
            <div className={styles.studentsection}>
              <div className={styles.search}>
                <SearchBar
                  placeholder="Search Program"
                  onChange={(e) => console.log(e.target.value)}
                />
              </div>
              <div className={styles.dropdown}>
                <Dropdown label="Room" options={["Room1", "Room2"]} />
                <Dropdown label="Labels" options={["Label 1", "Label 2"]} />
                <Dropdown label="Active" options={["Active", "Inactive"]} />
                <IconAndName
                  title="Check Availability"
                  bgColor="Primary_Color"
                  onClick={handlecheckAvailability}
                />
              </div>
            </div>

            <div className={styles.dynamicdata}>
              <Dynamic
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>

            <div className={styles.paginationTable}>
              <PaginationTable
                data={displayData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
      <CopyRight />
    </div>
  );
}

export default Program;
